import { IconButton, CircularProgress } from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";
import { useAppSelector } from "../../../../../redux/store";
import { useFileOperations } from "../../hooks/useFileOperations";

export const DownloadButton = ({ file, size = "small", sx = {} }: any) => {
  const { downloadLoading } = useAppSelector((state) => state.dropboxFolders) as any;
  const { handleFileDownload } = useFileOperations();

  const currentDownloadLoading = file?.path
    ? downloadLoading[file.path]
    : false;

  const handleClick = (e: any) => {
    e.stopPropagation();
    handleFileDownload(file);
  };

  return (
    <IconButton
      onClick={handleClick}
      size={size}
      title="Download file"
      disabled={currentDownloadLoading}
      sx={sx}
    >
      {currentDownloadLoading ? (
        <CircularProgress size={size === "small" ? 20 : 24} />
      ) : (
        <DownloadIcon />
      )}
    </IconButton>
  );
};

export default DownloadButton;
